export const iconFontAwesomeCampingRoute = (
	<i className="fa-solid fa-route"></i>
);
